import React, {ReactElement, useEffect} from 'react';
import AppHeader from '../../../components/appbar/AppBar';
import {useHistory} from 'react-router-dom';
import {EMPLOYEE_SIGNIN} from '../../../routes/route-constants';

import {setPageName} from '../../../lib/tagmanager';
import {pageName} from '../../../lib/constants';
import {getStoreEmployeeInfo} from '../../../core/localstorage-data';
import {useAppSelector} from '../../../redux/hooks';
import {storeInformation} from '../../../redux/storeInformationSlice';
const EmployeeLocation = (): ReactElement => {
  const navigate = useHistory();
  const employeeInfo = getStoreEmployeeInfo();
  const storeInformationData = useAppSelector(storeInformation);

  useEffect(() => {
    if (employeeInfo === null || storeInformationData.resultCode === '') {
      localStorage.clear();
      window.location.href = 'employeesignin';
    }
    setPageName(pageName.empLocationError);
    return () => {
      localStorage.clear();
      window.location.href = 'employeesignin';
    };
  }, []);
  const signOutHandler = () => {
    localStorage.clear();
    window.location.href = 'employeesignin';
  };
  return (
    <div className="h-full">
      <AppHeader bgColor="transparent" />
      <div className="py-4 px-8 top-spacing-ipad">
        <div className="grid place-items-center overflow-y-auto">
          <span className="font-roboto text-big text-center font-bold">
            Contact support
          </span>
        </div>
        <div className="mt-2">
          <p className="text-sm mt-2 text-black_zero text-center text-opacity-50 font-roboto">
            Please contact support team to re-map your store
          </p>
        </div>
        <button
          className="w-full h-50 primary normal mt-6 text-white font-bold focus:outline-none"
          onClick={signOutHandler}
          // disabled={isOTPNotFilled()}>
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default EmployeeLocation;
